// extracted by mini-css-extract-plugin
export var caption = "PageDataBodyGallery-module--caption--Pc5rS";
export var captionActive = "PageDataBodyGallery-module--captionActive--G7Um7";
export var gallery = "PageDataBodyGallery-module--gallery--LsFub";
export var galleryImage = "PageDataBodyGallery-module--galleryImage--X1TMm";
export var galleryImageActive = "PageDataBodyGallery-module--galleryImageActive--XIWVD";
export var gallerySlide = "PageDataBodyGallery-module--gallerySlide--20i2J";
export var gallerySlideActive = "PageDataBodyGallery-module--gallerySlideActive--WnxLe";
export var gallerySlides = "PageDataBodyGallery-module--gallerySlides--ahzfS";
export var slidesContainer = "PageDataBodyGallery-module--slidesContainer--VYoVI";